import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple"> Uwais Jawed </span>
            from <span className="purple"> Kolkata, India.</span>
            <br />
            I am currently a part time freelancer
            <br />I am pursuing my B.Tech in Computer Science from{" "}
            <span className="purple">
              {" "}
              Future Institute of Engineering and Management{" "}
            </span>
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing FPS Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Riding
            </li>
            <li className="about-activity">
              <ImPointRight /> Meditation
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Uwais</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
